//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'lodash'
import { mapGetters, mapMutations } from 'vuex'

import { assetPath } from 'core/util/filters'

export default {
    name: 'LookForGroup',

    data() {
        return {
            targetGroupTypes: this.$store.state.groups.prevLfgTargetGroupTypes || {},
        }
    },

    computed: {
        sortedGroupTypes() {
            return _.sortBy(this.groupTypeList, 'name')
        },

        ...mapGetters(['game', 'groupTypeList', 'getGenericGroupImage', 'optionOptions']),
    },

    methods: {
        lfgButtonStyle(groupType) {
            const groupImage = this.getGenericGroupImage(groupType)
            const groupBg = assetPath(`groups/large/${groupImage}`)
            return {
                backgroundImage: `url(${groupBg})`,
            }
        },

        toggleGroupType(groupType) {
            if (this.targetGroupTypes[groupType.id]) {
                this.$delete(this.targetGroupTypes, groupType.id)
            } else {
                this.$set(this.targetGroupTypes, groupType.id, {})
            }
        },

        toggleGroupOption(groupType, option, optionValue) {
            const currentOptions = this.targetGroupTypes[groupType.id] || {}
            const optionValues = currentOptions[option.id] || []

            if (optionValue.value === null) {
                // They're hitting "Any", reset all options
                this.$set(currentOptions, option.id, [])
                return
            }

            if (optionValues.includes(optionValue.value)) {
                this.$set(this.targetGroupTypes, groupType.id, {
                    ...currentOptions,
                    [option.id]: optionValues.filter(value => value !== optionValue.value),
                })
            } else {
                this.$set(this.targetGroupTypes, groupType.id, {
                    ...currentOptions,
                    [option.id]: [...optionValues, optionValue.value],
                })
            }
        },

        optionIsSelected(groupType, option, optionValue) {
            const currentOptions = this.targetGroupTypes[groupType.id] || {}
            const optionValues = currentOptions[option.id] || []
            if (optionValue.value === null && optionValues.length === 0) return true
            return optionValues.includes(optionValue.value)
        },

        findGroup() {
            this.setLfgTargetGroupTypes(this.targetGroupTypes)
            this.$vuedals.close(this)
        },

        ...mapMutations(['setLfgTargetGroupTypes']),
    },
}
